/**
 * Authorization Roles
 */
const authRoles = {
  admin: ["admin"],
  cashier: ["cashier"],
  onlyGuest: [],
};

export default authRoles;
